var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var MediaCapture = /** @class */ (function () {
    function MediaCapture(format) {
        this._chunks = [];
        this._state = "inactive";
        this._format = format;
    }
    Object.defineProperty(MediaCapture.prototype, "state", {
        get: function () {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaCapture.prototype, "data", {
        get: function () {
            return new Blob(this._chunks, { type: this._format });
        },
        enumerable: false,
        configurable: true
    });
    MediaCapture.prototype.isSupported = function () {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
            return true;
        return false;
    };
    MediaCapture.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ audio: true })];
                    case 1:
                        _a._stream = _c.sent();
                        this._mediaRecorder = new MediaRecorder(this._stream);
                        this._mediaRecorder.ondataavailable = this.onDataAvailable.bind(this);
                        this._mediaRecorder.onstart = this.onStart.bind(this);
                        this._mediaRecorder.onstop = this.onStop.bind(this);
                        this._mediaRecorder.start();
                        return [2 /*return*/, true];
                    case 2:
                        _b = _c.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MediaCapture.prototype.stop = function () {
        this._mediaRecorder.stop();
        this._stream.getTracks().forEach(function (pTrack) { return pTrack.stop(); });
    };
    MediaCapture.prototype.onStart = function () {
        this._chunks = [];
        this._state = this._mediaRecorder.state;
    };
    MediaCapture.prototype.onStop = function () {
        this._state = this._mediaRecorder.state;
        this.onStopped(this.data);
    };
    MediaCapture.prototype.onDataAvailable = function (e) {
        this._chunks.push(e.data);
    };
    return MediaCapture;
}());
export { MediaCapture };
